/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import InteractionEnum from 'astro/enum/interaction';

import DisableNeighborsInteraction from 'astro/server/interaction/disable.neighbors';
import IncreaseInflunceInteraction from 'astro/server/interaction/increase.influence';
import IncreaseResistanceInteraction from 'astro/server/interaction/increase.resistance';
import RedirectInflunceInteraction from 'astro/server/interaction/redirect.influence';

import FutureTargetInteraction from 'astro/server/interaction/future.target';
import ProjectPlatformInteraction from 'astro/server/interaction/project.platform';


export const makeInteraction = (cass) =>
{
  switch (cass.type)
  {
    case InteractionEnum.IncreaseInfluence:  return new IncreaseInflunceInteraction(cass);
    case InteractionEnum.IncreaseResistance: return new IncreaseResistanceInteraction(cass);
    case InteractionEnum.RedirectInfluence:  return new RedirectInflunceInteraction(cass);

    case InteractionEnum.ProjectPlatform:    return new ProjectPlatformInteraction(cass);
    case InteractionEnum.FutureTarget:       return new FutureTargetInteraction(cass);

    case InteractionEnum.DisableNeighbors:   return new DisableNeighborsInteraction(cass);
  }

  throw new Error('Unsupported interaction type');
}
